{
  "vitalsEntry": {
    "title": "உயிர் அறிகுறிகள்",
    "subtitle": "உயிர் அறிகுறிகளைப் பதிவு செய்து மீள்பார்வையிடவும்",
    "printLabel": "உயிர் அறிகுறிகளை அச்சிடவும்",
    "recordSection": "உயிர் அறிகுறிகளைப் பதிவு செய்யவும்",
    "save": "உயிர் அறிகுறிகளைப் பதிவு செய்யவும்",
    "cancel": "ரத்து செய்",
    "saving": "பதிவு செய்யப்படுகிறது...",
    "recordedSuccess": "உயிர் அறிகுறிகள் வெற்றிகரமாகப் பதிவு செய்யப்பட்டன",
    "recordedError": "உயிர் அறிகுறிகளைப் பதிவு செய்ய இயலவில்லை",
    "invalidEncounter": "சந்திப்பு ID செல்லுபடியாகாது.",
    "historyTitle": "சமீபத்திய உயிர் அறிகுறிகள்",
    "loadingHistory": "உயிர் அறிகுறிகள் ஏற்றப்படுகின்றன...",
    "loadError": "உயிர் அறிகுறிகளை ஏற்ற இயலவில்லை.",
    "emptyHistory": "இந்தச் சந்திப்பிற்கான உயிர் அறிகுறிகள் எதுவும் பதிவு செய்யப்படவில்லை.",
    "morseTitle": "மோர்ஸ் வீழ்ச்சி அபாய அளவீடு",
    "bradenTitle": "பிரேடன் அளவீடு (படுக்கைப் புண் அபாயம்)",
    "riskScalesSaved": "அபாய மதிப்பெண்கள் பதிவு செய்யப்பட்டன",
    "riskScalesFailed": "உயிர் அறிகுறிகள் சேமிக்கப்பட்டன, ஆனால் அபாய மதிப்பெண்களைப் பதிவு செய்ய இயலவில்லை"
  },
  "vitals": {
    "systolic": "சிஸ்டாலிக் BP",
    "diastolic": "டயஸ்டாலிக் BP",
    "heartRate": "இதயத் துடிப்பு வீதம்",
    "respiratoryRate": "மூச்சு வீதம்",
    "temperature": "வெப்பநிலை",
    "oxygenSaturation": "உயிர்வளி நிறைவு (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "வலி மதிப்பெண்",
    "weight": "எடை",
    "height": "உயரம்",
    "bmi": "BMI",
    "rangeError": "{{field}} {{min}} முதல் {{max}} வரை இருக்க வேண்டும்",
    "placeholders": {
      "temperature": "எ.கா. 37.0",
      "heartRate": "எ.கா. 72",
      "respiratoryRate": "எ.கா. 16",
      "oxygenSaturation": "எ.கா. 98",
      "systolic": "எ.கா. 120",
      "diastolic": "எ.கா. 80",
      "weight": "எ.கா. 70.5",
      "height": "எ.கா. 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "சாதாரண",
    "borderline": "எல்லைக்கோடு",
    "abnormal": "அசாதாரண",
    "critical": "நெருக்கடி"
  },
  "tableHeaders": {
    "dateTime": "தேதி/நேரம்",
    "temperature": "வெப்பநிலை",
    "heartRate": "துடிப்பு",
    "respiratoryRate": "மூச்சு",
    "bloodPressure": "BP",
    "oxygenSaturation": "SpO2",
    "weight": "எடை",
    "height": "உயரம்",
    "pain": "வலி"
  },
  "io": {
    "title": "உள்வரவு / வெளியேற்றம்",
    "addRecord": "பதிவை சேர்",
    "addRecordSection": "I/O பதிவைச் சேர்",
    "loading": "I/O பதிவுகள் ஏற்றப்படுகின்றன...",
    "loadError": "I/O பதிவுகளை ஏற்ற இயலவில்லை.",
    "empty": "இந்தச் சந்திப்பிற்கான I/O பதிவுகள் எதுவும் இல்லை.",
    "totals": {
      "intake": "மொத்த உள்வரவு",
      "output": "மொத்த வெளியேற்றம்",
      "balance": "நிகர சமநிலை",
      "totalsRow": "மொத்தம்",
      "netLabel": "நிகர"
    },
    "negativeWarning": "எதிர்மறை சமநிலை — திரவ நிலையை மறுபரிசீலனை செய்க",
    "columns": {
      "dateTime": "தேதி/நேரம்",
      "type": "வகை",
      "category": "பிரிவு",
      "amount": "அளவு (ml)",
      "notes": "குறிப்புகள்"
    },
    "fields": {
      "type": "வகை",
      "category": "பிரிவு",
      "amount": "அளவு (ml)",
      "notes": "குறிப்புகள்"
    },
    "type": {
      "intake": "உள்வரவு",
      "output": "வெளியேற்றம்"
    },
    "categoryPlaceholder": "பிரிவைத் தேர்ந்தெடு...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "விருப்ப குறிப்புகள்...",
    "save": "பதிவைச் சேமி",
    "cancel": "ரத்து செய்",
    "missingValueShort": "--",
    "toast": {
      "added": "I/O பதிவு சேர்க்கப்பட்டது",
      "addFailed": "I/O பதிவைச் சேர்க்க இயலவில்லை",
      "missingFields": "தேவையான புலங்களை நிரப்பவும்"
    }
  },
  "intake": {
    "oral": "வாய்வழி",
    "iv": "IV",
    "bloodProducts": "இரத்த உற்பத்திகள்",
    "tpn": "TPN",
    "tubeFeeding": "குழாய் ஊட்டம்",
    "other": "மற்றவை"
  },
  "output": {
    "urine": "சிறுநீர்",
    "drain": "வடிகுழாய்",
    "emesis": "வாந்தி",
    "stool": "மலம்",
    "bloodLoss": "இரத்த இழப்பு",
    "ngSuction": "NG உறிஞ்சல்",
    "other": "மற்றவை"
  },
  "wound": {
    "title": "காய பராமரிப்பு பதிவு",
    "subtitle": "சந்திப்பு #{{id}} — கட்டமைக்கப்பட்ட காய மதிப்பீடு",
    "newAssessment": "புதிய காய மதிப்பீடு",
    "dimensionsTitle": "பரிமாணங்கள் (செ.மீ)",
    "woundBedTitle": "காய தளம் (%)",
    "woundBedTotalWarning": "மொத்தம்: {{total}}% (100% ஆக இருக்க வேண்டும்)",
    "woundBedTotalOk": "மொத்தம்: 100%",
    "previousTitle": "முந்தைய மதிப்பீடுகள்",
    "empty": "இந்தச் சந்திப்பிற்கான காய மதிப்பீடுகள் எதுவும் பதிவு செய்யப்படவில்லை.",
    "invalidEncounter": "சந்திப்பு ID செல்லுபடியாகாது.",
    "save": "மதிப்பீட்டைச் சேமி",
    "savedSuccess": "காய மதிப்பீடு பதிவு செய்யப்பட்டது",
    "savedError": "காய மதிப்பீட்டைச் சேமிக்க இயலவில்லை",
    "fields": {
      "woundType": "காய வகை",
      "location": "இடம்",
      "stage": "நிலை",
      "length": "நீளம்",
      "width": "அகலம்",
      "depth": "ஆழம்",
      "granulation": "சதைப் பிசுக்கு",
      "slough": "மென்மையான இறந்த திசு (Slough)",
      "eschar": "கடினமான இறந்த திசு (Eschar)",
      "epithelial": "மேலணி திசு",
      "drainageType": "சீழ் வகை",
      "drainageAmount": "சீழ் அளவு",
      "surroundingSkin": "சுற்றுப்புற தோல்",
      "treatment": "வழங்கப்பட்ட சிகிச்சை",
      "painScore": "வலி மதிப்பெண் (0-10)",
      "notes": "குறிப்புகள்"
    },
    "placeholders": {
      "length": "எ.கா. 3.5",
      "width": "எ.கா. 2.0",
      "depth": "எ.கா. 0.5",
      "treatment": "வழங்கப்பட்ட காய பராமரிப்பை விவரிக்கவும்...",
      "notes": "கூடுதல் கவனிப்புகள்..."
    },
    "history": {
      "dimensionsLabel": "பரிமாணங்கள்",
      "drainageLabel": "சீழ்",
      "painLabel": "வலி",
      "treatmentLabel": "சிகிச்சை"
    },
    "stage": {
      "stage1": "நிலை 1",
      "stage2": "நிலை 2",
      "stage3": "நிலை 3",
      "stage4": "நிலை 4",
      "unstageable": "நிலை தீர்மானிக்க இயலாது",
      "deepTissue": "ஆழ்திசு காயம்",
      "na": "N/A"
    },
    "drainageType": {
      "none": "இல்லை",
      "serous": "நீர்மை",
      "sanguineous": "இரத்தம் கலந்த",
      "serosanguineous": "நீர்மை–இரத்தம் கலந்த",
      "purulent": "சீழ்க்கசிவு"
    },
    "drainageAmount": {
      "none": "இல்லை",
      "scant": "மிகச் சிறிது",
      "small": "சிறிய",
      "moderate": "மிதமான",
      "large": "அதிக",
      "copious": "மிக அதிக"
    },
    "woundType": {
      "pressure": "அழுத்தக் காயம்",
      "surgical": "அறுவை (காயம்)",
      "diabetic": "நீரிழிவுப் புண்",
      "venous": "சிரைப் புண்",
      "arterial": "தமனிப் புண்",
      "traumatic": "அதிர்ச்சி",
      "skinTear": "தோல் கிழிவு",
      "other": "மற்றவை"
    },
    "location": {
      "sacrum": "திரிக எலும்பு",
      "coccyx": "வால் எலும்பு",
      "leftHeel": "இடது குதிகால்",
      "rightHeel": "வலது குதிகால்",
      "leftTrochanter": "இடது ட்ரோகாண்டர்",
      "rightTrochanter": "வலது ட்ரோகாண்டர்",
      "abdomen": "வயிறு",
      "leftLeg": "இடது கால்",
      "rightLeg": "வலது கால்",
      "back": "முதுகு",
      "other": "மற்றவை"
    },
    "surroundingSkin": {
      "intact": "சேதமற்றது",
      "erythema": "சிவத்தல்",
      "macerated": "ஊறல்",
      "indurated": "கடினம்",
      "edematous": "வீக்கம்",
      "warm": "வெப்பம்",
      "discolored": "நிறமாற்றம்"
    }
  },
  "carePlan": {
    "title": "பராமரிப்பு திட்டங்கள்",
    "addPlan": "பராமரிப்பு திட்டத்தைச் சேர்",
    "newPlan": "புதிய பராமரிப்பு திட்டம்",
    "createPlan": "திட்டத்தை உருவாக்கு",
    "cancel": "ரத்து செய்",
    "empty": "இந்த நோயாளிக்கு பராமரிப்பு திட்டம் எதுவும் பதிவு செய்யப்படவில்லை.",
    "emptyGoals": "இலக்குகள் எதுவும் வரையறுக்கப்படவில்லை.",
    "goals": "இலக்குகள்",
    "addGoal": "இலக்கைச் சேர்",
    "saving": "சேமிக்கப்படுகிறது...",
    "loading": "பராமரிப்பு திட்டங்கள் ஏற்றப்படுகின்றன...",
    "loadError": "பராமரிப்பு திட்டங்களை ஏற்ற இயலவில்லை.",
    "fields": {
      "title": "தலைப்பு",
      "startDate": "தொடக்க தேதி",
      "targetDate": "இலக்கு தேதி",
      "description": "விளக்கம்",
      "target": "இலக்கு"
    },
    "placeholders": {
      "title": "எ.கா. வீழ்ச்சி தடுப்பு திட்டம்",
      "description": "இலக்கு விளக்கம்",
      "target": "எ.கா. 30 நாட்களில் வீழ்ச்சி இல்லை"
    },
    "history": {
      "startLabel": "தொடக்கம்",
      "targetLabel": "இலக்கு",
      "goalsLabel": "இலக்குகள்"
    },
    "status": {
      "active": "செயலில்",
      "completed": "முடிந்தது",
      "cancelled": "ரத்துசெய்யப்பட்டது"
    },
    "goalStatus": {
      "inProgress": "முன்னேற்றத்தில்",
      "achieved": "அடைந்தது",
      "notAchieved": "அடையவில்லை"
    },
    "toast": {
      "planCreated": "பராமரிப்பு திட்டம் உருவாக்கப்பட்டது",
      "planCreateFailed": "பராமரிப்பு திட்டத்தை உருவாக்க இயலவில்லை",
      "goalAdded": "இலக்கு சேர்க்கப்பட்டது",
      "goalAddFailed": "இலக்கைச் சேர்க்க இயலவில்லை",
      "planValidation": "தலைப்பு மற்றும் தொடக்க தேதி கட்டாயம்",
      "goalValidation": "விளக்கம் மற்றும் இலக்கு கட்டாயம்"
    }
  }
}
